import { DepartmentInterface, UserInterface } from "@/shared/model/api.types";
import departmentApi from "../api/department.api";
import userApi from "../api/user.api";
import { useWorkspace } from "./useWorkspace";
import { useErrorAlert } from "@/shared/lib/useErrorAlert";

export const useWorkspaceActions = () => {
  const { setLoading, setError, setUsers, setDepartments } = useWorkspace()
  const { showErrorAlert } = useErrorAlert()  

  const fetchUsers = async(): Promise<UserInterface[] | null> => {
    setLoading("users", true);
    setError("users", null)
    try {
      const response = await userApi.getAll();
      setUsers(response.data);
      return response.data
    } catch (error: any) {
      setError("users", error?.message || String(error));
      showErrorAlert(error)
      return null
    }finally{
      setLoading("users", false);
    }
  }

  const fetchDepartments = async(): Promise<DepartmentInterface[] | null> => {
    setLoading("departments", true);
    setError("departments", null)
    try {
      const response = await departmentApi.getAll();
      setDepartments(response.data);
      return response.data
    } catch (error: any) {
      setError("departments", error?.message || String(error));
      showErrorAlert(error)
      return null
    } finally {
      setLoading("departments", false);
    }
  }

  return { fetchDepartments, fetchUsers }
}
